export default __webpack_public_path__ + "static/media/rotate-right.dacc5719.svg";